import L from "leaflet";

export const VenueIconSuccess = L.icon({
  iconUrl: require("../../assets/location_success.png"),
  iconSize: [38, 53]
});
